const breadCrumb = "Lotação de Servidores - Diretores e Secretários";

const routes = [
  {
    path: "/relacao-diretores-secretarios",
    name: "relacao-diretores-secretarios",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/RelacaoDiretoresSecretarios/RelacaoDiretoresSecretarios.vue"
      ),
  },
];

export default routes;
